import React, { Component } from 'react';
import _ from 'lodash';

import TinyNodeInfrastructuresTable from '../components/TinyNodeInfrastructuresTable';
import TinyNodeParkinglocationsSelect from '../components/TinyNodeParkinglocationsSelect';
import TinyNodeInfrastructuresForm from '../components/TinyNodeInfrastructuresForm';

import TinyNodeInfrastructuresModel from '../components/TinyNodeInfrastructuresModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class TinyNodeSensorsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: false,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    tinyNodeInfrastructuresFormModalVisible: false,
    tinyNodeParkinglocationId: null
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.tinyNodeParkinglocationId);

    // Checking auto reload data    
    this.intervalId = setInterval(() => {
      if (this.state.autoReload && this.state.tinyNodeParkinglocationId) {
        this.loadData(this.state.tinyNodeParkinglocationId);
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData(tinyNodeParkinglocationId) {
    this.setState({
      dataLoading: true
    });
    TinyNodeInfrastructuresModel.getAll(tinyNodeParkinglocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.');
        this.setState({
          dataLoading: false,
        });
      });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>TinyNode - Infrastruktura</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <TinyNodeParkinglocationsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", tinyNodeParkinglocationId: value });
                  }}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Najít seriové číslo"
                  value={this.state.searchedTextValue}
                  onSearch={(searchText) => {
                    const dataAll = this.state.dataAll;
                    this.setState({
                      data: _.filter(dataAll, (d) => {
                        return d.nodeID.toString().startsWith(searchText);
                      })
                    });
                  }}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.tinyNodeParkinglocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'TINYNODE_INFRASTRUCTURES_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ tinyNodeInfrastructuresFormModalVisible: true }) }}>Nový prvek</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <TinyNodeInfrastructuresForm
            type="modal"
            modalVisible={this.state.tinyNodeInfrastructuresFormModalVisible}
            onModalCancel={() => { this.setState({ tinyNodeInfrastructuresFormModalVisible: false }) }}
            onSuccess={(form, values) => {
              TinyNodeInfrastructuresModel.create(values)
                .then(() => {
                  form.resetFields(['nodeID', 'description']);
                  this.loadData(this.state.tinyNodeParkinglocationId);
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <TinyNodeInfrastructuresTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onAnyFormSuccess={() => {              
                this.loadData(this.state.tinyNodeParkinglocationId);              
            }}
            onRemoveRow={(id) => {
              TinyNodeInfrastructuresModel.remove(id)
                .then(() => {
                  this.loadData(this.state.tinyNodeParkinglocationId);
                })
                .catch((err) => {
                  message.warning('Prvek infrastruktury se nepodařilo smazat. Prosím kontaktujte správce systému!');
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TinyNodeSensorsScreen;



// WEBPACK FOOTER //
// ./src/screens/TinyNodeInfrastructuresScreen.js